import { cn, snakeToTitleCase } from 'lib/helpers/utility';

const PracticeStatusCell = ({ status, textClassName }) => {
  const statusClass = cn(
    'flex h-full max-h-5 w-fit items-center justify-center rounded-md px-1.5 text-xs text-neutral-900 border border-solid border-neutral-200 bg-neutral-100',
    status === 'pending' ? 'border-warning-200 bg-warning-100' : null,
    status === 'active' ? 'border-success-200 bg-success-100' : null,
    status === 'inactive' ? 'border-danger-200 bg-danger-100' : null
  );
  return (
    <div className="flex h-full w-full items-center">
      <div className={statusClass}>
        <span className={textClassName}>{snakeToTitleCase(status)}</span>
      </div>
    </div>
  );
};

export default PracticeStatusCell;
